<template>
  <div class="notifications-container">
    <transition-group name="notification">
      <div 
        v-for="notification in notifications" 
        :key="notification.id"
        :class="['notification', `notification-${notification.type}`]"
      >
        <div class="notification-content">
          <span class="notification-icon">
            {{ getIconForType(notification.type) }}
          </span>
          {{ notification.message }}
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'NotificationSystem',
  data() {
    return {
      notifications: [],
      nextId: 1
    }
  },
  methods: {
    addNotification(message, type = 'success', duration = 3000) {
      const id = this.nextId++;
      const notification = { id, message, type };
      
      this.notifications.push(notification);
      
      setTimeout(() => {
        this.removeNotification(id);
      }, duration);
      
      return id;
    },
    
    removeNotification(id) {
      const index = this.notifications.findIndex(n => n.id === id);
      if (index !== -1) {
        this.notifications.splice(index, 1);
      }
    },
    
    showSuccess(message) {
      return this.addNotification(message, 'success');
    },
    
    showError(message) {
      return this.addNotification(message, 'error', 5000);
    },
    
    showInfo(message) {
      return this.addNotification(message, 'info');
    },
    
    getIconForType(type) {
      switch (type) {
        case 'success': return '✓';
        case 'error': return '✕';
        case 'info': return 'ℹ';
        default: return '';
      }
    }
  }
}
</script>

<style scoped>
.notifications-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 300px;
}

.notification {
  padding: 15px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  color: white;
}

.notification-success {
  background-color: #42b983;
}

.notification-error {
  background-color: #ff5252;
}

.notification-info {
  background-color: #2196f3;
}

.notification-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notification-icon {
  font-size: 18px;
  font-weight: bold;
}

/* 动画效果 */
.notification-enter-active,
.notification-leave-active {
  transition: all 0.3s;
}

.notification-enter-from {
  transform: translateX(100px);
  opacity: 0;
}

.notification-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
